export default class ClubExamSettings {

    constructor() {
        this.id = null;
        this.activeForOfferings = false;
        this.hasAccessToOfferingModule = false;
        this.usabilityPassEnabled = false;
        this.usabilityPassAvailable = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubExamSettings = new ClubExamSettings()
        clubExamSettings.id = data.id;
        clubExamSettings.activeForOfferings = data.activeForOfferings;
        clubExamSettings.hasAccessToOfferingModule = data.hasAccessToOfferingModule;
        clubExamSettings.usabilityPassEnabled = data.usabilityPassEnabled;
        clubExamSettings.usabilityPassAvailable = data.usabilityPassAvailable;

        return clubExamSettings;
    }
}
